export default __webpack_public_path__ + "static/media/purityimage.b74de58f.png";